import GenericRequest, { METHOD_POST } from '../../../../shared/webservices/GenericRequest';
import { ApiEndpoints } from '../../../../shared/webservices/endpoint';

export default class DocumentsTaskLinkRequest extends GenericRequest {

    company_parent_id;
    company_child_id;
    construction_id;
    year;
    month;

    constructor(companyParentId, companyChildId, construction_id, month = null, year = null) {
        super(METHOD_POST, ApiEndpoints.TASK_LINK_DOCUMENTS);

        this.company_parent_id = companyParentId;
        this.company_child_id = companyChildId;
        this.construction_id = construction_id;
        this.month = month;
        this.year = year;
    }

    overrideRequest() {
        const request = {};
        request.criteria = {};
        if ( this.company_parent_id ) request.criteria.company_parent_id = this.company_parent_id;
        if ( this.company_child_id ) request.criteria.company_child_id = this.company_child_id;
        if ( this.construction_id ) request.criteria.construction_id = this.construction_id;
        if ( this.month ) request.criteria.month = this.month;
        if ( this.year ) request.criteria.year = this.year;
        return request;
    }
}



// WEBPACK FOOTER //
// ./src/app/my-outsources/tasks/list/ws/DocumentsTaskLinkRequest.js